export class UploadError extends Error {
  public code?: string;

  constructor(message: string = '', code?: string) {
    super(message);
    this.name = 'UploadError';
    this.message = message;
    this.code = code;
  }
}

export const isUploadError = (error: Error): boolean => error instanceof UploadError;
